import { Asset } from './asset';
import { AssetState } from './assetState';
import { z } from 'zod';

export type UiAsset = z.infer<typeof UiAsset>;

export const UiAsset = Asset.extend({
    state: AssetState.nullish(),
    children: Asset.array().nullish(),
});
